export default {
	MANUAL: 'manual',
	BY_VALUE: 'by-value',
	BY_LABEL: 'by-label'
}
